// export const NEXT_PUBLIC_PROD_URL = "https://backend.Al-Saboor.com/api/"
// // export const NEXT_PUBLIC_PROD_IMAGE_URL = "https://backend.Al-Saboor.com/"

export const NEXT_PUBLIC_PROD_URL = "https://al-saboor-backend.vercel.app/api/";
export const NEXT_PUBLIC_PROD_IMAGE_URL =
    "https://al-saboor-backend.vercel.app/";

// export const NEXT_PUBLIC_PROD_URL = "http://localhost:3001/api/";
// export const NEXT_PUBLIC_PROD_IMAGE_URL = "http://localhost:3001/";
